export const AnchorLinks = (function () {
	'use strict';

	let $win, $anchorLink;

	function init() {
		$win = jQuery(window);
		$anchorLink = $('a[href^="#"]');

		if (location.hash) {
			if ($(location.hash).length > 0) {
				jumpToEl(location.hash);
			}
		}

		$anchorLink.click(function () {
			let id = $(this).attr('href');

			if (id.length > 1 && $(id).length > 0) {
				jumpToEl(id);
			}
		});
	}

	function jumpToEl(id) {
		$('html, body').scrollTop($(id).offset().top - $('.site-header').height());
	}

	return {
		init: init,
	};
})();
